import {
	all,
	compose,
	curry,
	defaultTo,
	forEachObjIndexed,
	includes,
	isEmpty,
	isNil,
	map,
	mergeRight,
	sort,
} from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { alphabetSorterCS, getCodelistObjectById, toIsoDateFormat } from 'utils';

import { INFORMATION, TASK } from './constants';

export const sortAndMergeTaskTypes = (taskTypeList, taskTypesCodelist) =>
	compose(
		sort((prevItem, nextItem) => {
			// sort by type
			if (prevItem.informative > nextItem.informative) return 1;
			if (prevItem.informative < nextItem.informative) return -1;
			// sort by alphabet
			if (!prevItem.description || !nextItem.description) return 0;
			return alphabetSorterCS(prevItem.description, nextItem.description);
		}),
		map((taskType) => mergeRight(taskType, getCodelistObjectById(taskType.taskTypeId, taskTypesCodelist))),
	)(taskTypeList);

export const renameKeysByRelations = curry((relations, formData) => {
	const requestData = {};

	forEachObjIndexed((val, key) => {
		if (relations[key] !== undefined && !isNil(val) && !isEmpty(val)) {
			requestData[relations[key]] = val;
		}
	}, formData);

	return requestData;
});

export const requestFactory = (formData, taskTypeId) => {
	const filter = [];

	forEachObjIndexed((val, key) => {
		if (key !== 'taskTypeId' || !taskTypeId) {
			if (key !== 'deadlineFrom' && key !== 'deadlineTo') {
				if (val === 'isNull') {
					filter.push({
						operation: 'isNull',
						property: key,
					});
				} else {
					filter.push({
						operation: 'equal',
						property: key,
						value: [formData[key]],
					});
				}
			} else if (key === 'deadlineFrom') {
				filter.push({
					operation: 'notLessThan',
					property: 'deadlineDate',
					value: [toIsoDateFormat(formData[key])],
				});
			} else if (key === 'deadlineTo') {
				filter.push({
					operation: 'notGreaterThan',
					property: 'deadlineDate',
					value: [toIsoDateFormat(formData[key])],
				});
			}
		}
	}, formData);

	if (Number.isInteger(taskTypeId)) {
		filter.push({
			operation: 'equal',
			property: 'taskTypeId',
			value: [`${taskTypeId}`],
		});
	}

	return { filter };
};

export const getTaskTypesIds = (codeList) => {
	const taskIds = [];
	const infoIds = [];

	// eslint-disable-next-line array-callback-return
	codeList.map((item) => {
		item.informative === TASK && taskIds.push(item.id);
		item.informative === INFORMATION && infoIds.push(item.id);
	});

	return {
		taskIds,
		infoIds,
	};
};

export const getPolicyAdmins = (admins) => {
	return defaultTo(
		[],
		admins.filter((admin) => admin.sellerIn),
	);
};

/* gets first policy admin but one with sellerIn (not - sub sellers) */
export const getDefaultPolicyAdmin = (admins) => {
	return defaultTo([], getPolicyAdmins(admins))[0];
};

export const filterTasksToInformationById = (tasks, informationIds, selectedTasks) =>
	tasks
		.filter((item) => includes(item.taskTypeId, informationIds))
		.filter((item) => includes(item.id, selectedTasks));

export const generateMarkAllTaskTypeTasksCountObject = (tasks, markAllTaskTypes) => {
	const obj = {};

	const onlyMarkAllTasks = tasks.filter((task) => includes(task?.taskTypeId, markAllTaskTypes));

	onlyMarkAllTasks.forEach((task) => {
		if (!obj[task.taskTypeId]) {
			// if no prop > create it
			obj[task.taskTypeId] = 1;
		} else {
			// if prop exists already > increment the value
			obj[task.taskTypeId]++;
		}
	});

	return obj;
};

export const noneOfCriteriaFilterFieldsFilled = (formData) => {
	const values = Object.values(formData);
	return all(isNilOrEmpty)(values);
};
